// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Message } from "../../../data/messaging/message";
import { MessageContact } from "../../../data/messaging/message-contact";
import { MessageAttachment } from "../../../data/messaging/message-attachment";
import { EnvelopeDocument } from "../base/envelope-document";

export class MessageDocument extends EnvelopeDocument {
	public override Item: Message = new Message();
	public Recipients: MessageContact[] = [];
	public Attachments: MessageAttachment[] = [];
}